var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-banner"},[_c('div',{staticClass:"grid grid--container"},[_c('div',{staticClass:"row row--lg-h-center"},[_c('div',{class:("col " + _vm.columns)},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }